import { useMemo } from "react";

import { Season, useGetSeasonsByUserLeague } from "../../../redux/slices";
import { SportPlay } from "../../../types";
import { TSelectItem, useSelect } from "../../select";
import { UseSelect } from "../types";

export type SelectSeasonItem = TSelectItem<Season>;

export const useSelectSeason = <TPlay extends SportPlay>({ editingPlay, updatePlay }: UseSelect<TPlay>) => {
  const { data: seasons } = useGetSeasonsByUserLeague();

  const seasonItems: SelectSeasonItem[] = useMemo(
    (): SelectSeasonItem[] => seasons?.map((s) => ({ ...s, label: s.abrv })) || [],
    [seasons]
  );

  const selectedSeason = useMemo(
    () => seasonItems.find((s) => s.abrv === editingPlay.season),
    [editingPlay, seasonItems]
  );

  const handleChangeSeason = (item: TSelectItem<Season>) => {
    updatePlay((prevValue) => ({ ...prevValue, season: item.abrv }));
  };

  const seasonSelect = useSelect({
    items: seasonItems,
    initialSelectedItem: selectedSeason,
    onChange: handleChangeSeason,
  });

  return { seasonSelect };
};
